// PageHeader — standard page title row: icon + title (+ optional subtitle)
// on the left, optional action node on the right. Thin composition over
// PageHeaderTitle so a swap-in is pixel-equivalent to the hand-rolled
// header rows on Properties / Market Insights / Dashboard.
import React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme, TypographyProps } from "@mui/material";
import PageHeaderTitle from "../PageHeaderTitle";

interface PageHeaderProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  titleVariant?: TypographyProps["variant"];
  /** Right-side action node (button, chip row, refresh, …). */
  action?: React.ReactNode;
  /** Extra inline content after the title (badges etc.) — forwarded to PageHeaderTitle. */
  children?: React.ReactNode;
  /** sx for the outer row (margins, wrap behaviour) — merged over the defaults. */
  sx?: SxProps<Theme>;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  title,
  subtitle,
  titleVariant,
  action,
  children,
  sx,
}) => (
  <Box
    sx={[
      {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: 3,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <PageHeaderTitle
      icon={icon}
      title={title}
      subtitle={subtitle}
      titleVariant={titleVariant}
    >
      {children}
    </PageHeaderTitle>
    {action}
  </Box>
);

export default PageHeader;
